import { z } from 'zod';
/**
 * Money as it crosses the wire. `Decimal.toJSON` emits a string, so a serialised
 * amount is always a string by the time a client sees it.
 */
export const MoneySchema = z.object({
    amount: z.string().regex(/^\d+(\.\d+)?$/),
    currency: z.enum(['USD']),
});
export const ZERO_USD = { amount: '0', currency: 'USD' };
/**
 * Formats money as a localized currency string.
 *
 * @param money - The amount and its currency
 * @param formatOptions - `Intl.NumberFormatOptions` overrides, as `toLocaleString` takes
 * @returns The formatted currency string
 */
export function formatMoney(money, formatOptions = {}) {
    return Number(money.amount).toLocaleString(['en-US'], {
        style: 'currency',
        currency: money.currency,
        ...formatOptions,
    });
}
//# sourceMappingURL=money.js.map